<template>
  <div>
	<CaptchaClickDialog
		v-model:visible="showCaptcha"
		:taskId="captchaTaskId"
		:tipImageUrl="captchaTipImageUrl"
    :bgImageUrl="captchaBgImageUrl"
	/>
	<!-- 加这个 -->
	<CaptchaSmsDialog
		v-model:visible="showSmsCaptcha"
		:taskId="smsTaskId"
	/>
   
  <!-- ====================== 【已加强】RPA 弹窗 ====================== -->
  <el-dialog
      v-model="showRpaProgress"
      title="取得发票自动获取"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="canCloseDialog"
    >
      <div class="p-4">
        <!-- ====================== 【新增：弹窗内日期选择】 ====================== -->
        <div class="mb-4">
          <label class="block text-sm font-medium mb-2">选择取票日期</label>
          <div class="flex items-center gap-2">
            <DatePicker 
              v-model="params.start" 
              :clearable="false" 
              :option="{ end: params.end }" 
              class="flex-1"
            />
            <span>至</span>
            <DatePicker 
              v-model="params.end" 
              :clearable="false" 
              :option="{ start: params.start }" 
              class="flex-1"
            />
          </div>
        </div>

        <div class="mb-4 p-3 bg-gray-50 rounded">
          <div class="font-bold mb-1">⚠️ 注意事项</div>
          <div class="text-sm text-gray-600 space-y-1">
            <div>1. 获取发票的时间不能超过三个月</div>
            <div>2. 请确保电子税务局账号密码正确</div>
            <div>3. 过程中可能需要多次验证码，请留意弹窗</div>
            <div>4. 请勿重复点击，等待任务自动完成</div>
            <div>5. 获取时间根据发票数量决定，请耐心等待</div>
            <div>6. 尽量不要中途退出（强制终止并不能100%终止）</div>
            <div>7. 每次使用后需等待3分钟后再次执行</div>
            <div>8. 不同地方税务局可能略有差异，如异常可反馈给平台</div>
          </div>
        </div>

        <!-- 状态展示区域 -->
        <div class="my-4 p-3 bg-blue-50 rounded min-h-[80px]">
          <div class="text-sm">{{ rpaStatusText }}</div>
        </div>
      </div>

      <template #footer>
        <el-button @click="cancelRpaTask" :disabled="!isRpaRunning">强制终止</el-button>
        <el-button
  type="primary"
  @click="startGetInvoiceList()"
  :loading="isRpaRunning"
  :disabled="isRpaRunning || rpaCooldown > 0"
>
  {{ rpaCooldown > 0 ? `请等待 ${rpaCooldown} 秒` : '启动取票' }}
</el-button>
      </template>
    </el-dialog>
    <!-- ====================== 【结束加强】 ====================== -->
    <vxe-toolbar class-name="!px-8px" perfect>
      <template #buttons>
        <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
          <div>{{ startDate }} 至 {{ endDate }}</div>
          <template #content>
            <Form style="padding: 10px" labelWidth="100" class="compact">
              <FormItem label="日期">
                <div class="flex items-center">
                  <DatePicker v-model="params.start" :clearable="false" :option="{end:params.end}"/>
                  <span class="mx-8px">至</span>
                  <DatePicker v-model="params.end" :clearable="false" :option="{start:params.start}"/>
                </div>
              </FormItem>
              <FormItem label="发票号码">
                <Input v-model="params.invoiceNumber"/>
              </FormItem>
              <FormItem label="是否生成凭证">
                <Select placeholder="全部" :datas="[{key:1,title:'是'},{key:0,title:'否'}]" v-model="params.voucherId"/>
              </FormItem>
              <FormItem label="发票状态">
                <Select placeholder="全部" :datas="[{key:'正常',title:'正常'},{key:'作废',title:'作废'}]" v-model="params.state"/>
              </FormItem>
              <FormItem label="发票种类">
                <Select placeholder="全部" :datas="categoryList" v-model="params.category"/>
              </FormItem>
              <FormItem label="客户名称">
                <Input v-model="params.customerName"/>
              </FormItem>
              <FormItem>
                <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
                <Button @click="paramsDropdown.hide()">取消</Button>
                <Button @click="resetForm">重置</Button>
              </FormItem>
            </Form>
          </template>
        </DropdownCustom>
      </template>
      <template #tools>
        <DropdownMenu
            class="mr-12px"
            :datas="categoryList"
            :toggleIcon="false"
            @clickItem="showNewForm($event,null)">
          <vxe-button v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' && User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" status="primary" icon="fa fa-plus">新增发票</vxe-button>
        </DropdownMenu>
<vxe-button v-if="User.role == 'ManagerApexe' || User.role == 'MakingApexe'" icon="h-icon-refresh" @click="getListOut()">一键取票</vxe-button>
        <vxe-button icon="h-icon-refresh" @click="loadList()">刷新</vxe-button>
        <vxe-button @click="$emit('download',{type:'IN',params})" icon="fa fa-download">导出</vxe-button>
        <vxe-button v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' &&User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="importIn" icon="fa fa-upload">模版导入</vxe-button>
        <vxe-button v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' && User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="importInNum" icon="fa fa-upload">数电票导入</vxe-button>
        <DropdownMenu
            v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' &&User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'"
            class="mx-12px"
            :datas="['批量删除','指定业务类型','批量认证','批量反认证']"
            :toggleIcon="false"
            @clickItem="doAction($event)">
          <vxe-button v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' &&User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" icon="fa fa-copy">批量操作</vxe-button>
        </DropdownMenu>
        <!-- generateVoucher -->
        <vxe-button v-if="User.role!=='ViewApexe' && User.role!=='ViewLow' &&User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="openedDateSelect=true" icon="fa fa-file-o">生成凭证</vxe-button>
      </template>
    </vxe-toolbar>
    <div class="flex-1 ">
      <vxe-table :loading="loading" ref="xTable" :data="pageList.results" height="auto" border :checkbox-config="{checkMethod:checkMethod,visibleMethod:checkMethod}">
        <vxe-column type="checkbox" width="50" align="center" fixed="left"/>
        <vxe-column title="发票种类" field="category" width="140" :formatter="formatInvoiceCategory" />
        <vxe-column title="开票日期" field="tradeDate" width="100"/>
        <vxe-column title="数电票代码" field="electricInvoiceCode" width="150"/>
        <vxe-column title="发票代码" field="invoiceCode" width="150"/>
        <vxe-column title="发票号码" field="invoiceNumber" width="150"/>
        <vxe-column title="认证日期" field="checkDate" width="100"/>
        <vxe-column title="供应商名称" field="customerName" width="140"/>
        <vxe-column title="业务类型" field="businessType" width="100"/>
        <vxe-column title="合计金额" field="taxAmountExcluded" width="120" align="right" formatter="toMoney"/>
        <vxe-column title="税率" field="rate" align="right" width="120" :formatter="({cellValue})=>cellValue?cellValue+'%':''"/>
        <vxe-column title="合计税额" field="taxAmount" width="120" align="right" formatter="toMoney"/>
        <vxe-column title="价税合计" field="amount" width="120" align="right" formatter="toMoney"/>
        <vxe-column title="关联凭证" field="voucher" align="center" width="80">
          <template #default="{row}">
            <router-link class="text-hover primary-color" @success="loadList" width="1120px"
                         v-if="row.voucherId"
                         :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
              {{ row.voucher }}
            </router-link>
          </template>
        </vxe-column>
        <vxe-column title="操作" width="180" align="center" fixed="right">
          <template #default="{row}">
            <span @click="showNewForm(row.category,row,true)" class="text-hover mr-16px"> <i class="fa fa-file-text"></i> 详情</span>
            <span v-if="!row.voucherId && !row.checkDate && User.role!=='View'" @click="showNewForm(row.category,row)" class="text-hover mr-16px"> <i class="fa fa-edit"></i> 编辑</span>
            <span v-if="!row.voucherId && !row.checkDate && User.role!=='View'" @click="remove([row])" class="text-hover"> <i class="fa fa-trash"></i> 删除</span>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <vxe-pager @page-change="onPageChange"
               v-model:current-page="page.page"
               v-model:page-size="page.pageSize"
               :total="pageList.total"
               :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      <template #left>
        <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
      </template>
    </vxe-pager>
    <div>
      <Modal v-model="openedDateSelect">
        <div style="padding: 10px;">请选择生成凭证的日期规则</div>
        <div style="padding: 10px;padding-top: 0px;">
          <Radio :value='paramDate[0].key' v-model="paramDateValue">按发票日期</Radio>
          <Radio style="margin-left: 8px;" :value='paramDate[1].key' v-model="paramDateValue">按会计期间</Radio>
        </div>
        <div slot="footer" style="display: flex;justify-content: right;">
          <Button @click="openedDateSelect=false">取消</Button>
          <Button color="blue" @click="generateVoucher();openedDateSelect=false;">确定</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "IncomeInvoice"
}
</script>

<script setup>
// 【新增】页面销毁时强制清空定时器，避免内存泄漏
import { onMounted } from 'vue';
import { onUnmounted } from 'vue';
import {h, reactive, ref, toRefs} from "vue";
import {layer} from "@layui/layer-vue";
import InvoiceForm from "@/views/invoice/InvoiceForm";
import {Invoice} from "@/api/Invoice";
import {confirm, message} from "heyui.ext";
import InvoiceChangeBusinessType from "@/views/invoice/InvoiceChangeBusinessType";
import InvoiceCheck from "@/views/invoice/InvoiceCheck";
import InvoiceGenerateVoucher from "@/views/invoice/InvoiceGenerateVoucher";
import manba from "manba";
import InvoiceImport from "@/views/invoice/InvoiceImport";
import {useStore} from "vuex";
import InvoiceNumImport from "@/views/invoice/InvoiceNumImport";
import CaptchaClickDialog from '../../components/CaptchaClickDialog.vue';
import CaptchaSmsDialog from '../../components/CaptchaSmsDialog.vue';

const store = useStore();
const User = store.state.User;

const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());

const paramDate = ref([{ title: '按发票日期', key: 'a1',}, { title: '按会计期间', key: 'a2' }])
const paramDateValue = ref("a2")
const openedDateSelect = ref(false);

const showCaptcha = ref(false);
const captchaTaskId = ref('');
const captchaImageUrl = ref('');

// 加这三个
const showSmsCaptcha = ref(false);
const smsTaskId = ref('');

const captchaTipImageUrl = ref('');
const captchaBgImageUrl = ref('');

const canCloseDialog = ref(true); // 控制关闭按钮是否显示
// RPA 进度弹窗
const showRpaProgress = ref(false);
const rpaStatusText = ref("就绪，请点击【启动取票】开始");

// 顶部添加
let rpaPollingTimer = null; // RPA轮询定时器
const isRpaRunning = ref(false); // 标记任务是否执行中

// ====================== RPA 冷却 3 分钟（按账套持久化）======================
const currentSetId = store.state.currentAccountSets.id;
const COOLDOWN_KEY = "rpa_cooldown_expire_time_" + currentSetId;

const rpaCooldown = ref(0);
const rpaCooldownTimer = ref(null);

// 页面加载时恢复缓存
onMounted(() => {
  restoreCooldownFromCache();
});

// 从本地缓存恢复当前账套冷却时间
function restoreCooldownFromCache() {
  console.log("恢复RPA冷却时间",localStorage.getItem(COOLDOWN_KEY));

  const expireTime = localStorage.getItem(COOLDOWN_KEY);
  if (!expireTime) return;

  const now = Date.now();
  const remain = Math.ceil((expireTime - now) / 1000);
  if (remain > 0) {
    rpaCooldown.value = remain;
    startCooldownTimer();
  } else {
    localStorage.removeItem(COOLDOWN_KEY);
    rpaCooldown.value = 0;
  }
}

// 启动冷却计时
function startCooldown() {
  if (rpaCooldownTimer.value) clearInterval(rpaCooldownTimer.value);

  const expireTime = Date.now() + 180 * 1000;
  console.log("启动计时器",COOLDOWN_KEY, expireTime)
  localStorage.setItem(COOLDOWN_KEY, expireTime);
  rpaCooldown.value = 180;
  startCooldownTimer();
}

// 冷却倒计时定时器
function startCooldownTimer() {
  rpaCooldownTimer.value = setInterval(() => {
    const expireTime = localStorage.getItem(COOLDOWN_KEY);
    if (!expireTime) {
      clearInterval(rpaCooldownTimer.value);
      rpaCooldown.value = 0;
      return;
    }

    const remain = Math.ceil((expireTime - Date.now()) / 1000);
    rpaCooldown.value = remain > 0 ? remain : 0;

    if (remain <= 0) {
      clearInterval(rpaCooldownTimer.value);
      localStorage.removeItem(COOLDOWN_KEY);
      rpaCooldownTimer.value = null;
    }
  }, 1000);
}

// 取消 RPA 任务
const cancelRpaTask = async () => {
  try {
    await Invoice.cancelRpaTask();
    canCloseDialog.value = true;  // 👈 加这行
    message.success("已取消任务");
    stopRpaPolling();
    isRpaRunning.value = false;
    rpaStatusText.value = "任务已取消";
	// ========== 加这一行 ==========
    startCooldown();
    //showRpaProgress.value = false;
    showCaptcha.value = false;
    showSmsCaptcha.value = false;
  } catch (err) {
    message.error("取消失败");
  }
};

// 抽离成独立方法，逻辑更清晰
const checkRpaTaskStatus = async () => {
  try {
    const res = await Invoice.getRpaTaskStatus();
    const { status, errorMsg, captcha } = res;

    switch (status) {
      case "WAITING_CAPTCHA":
        rpaStatusText.value = "等待验证码，请完成验证...";
        handleCaptchaStatus(captcha);
        break;

      case "SUCCESS":
        stopRpaPolling();
        canCloseDialog.value = true;  // 👈 加
        isRpaRunning.value = false;
        rpaStatusText.value = "✅ 发票获取并导入完成！";
        message.success("发票获取并导入完成！");
        loadList();
        showCaptcha.value = false;
        showSmsCaptcha.value = false;
// ========== 加这一行 ==========
    startCooldown();
        break;

      case "FAILED":
        stopRpaPolling();
        canCloseDialog.value = true;  // 👈 加
        isRpaRunning.value = false;
        rpaStatusText.value = "❌ 任务失败：" + errorMsg;
        message.error("发票获取失败：" + errorMsg);
        showCaptcha.value = false;
        showSmsCaptcha.value = false;
// ========== 加这一行 ==========
    startCooldown();
        break;

      case "RUNNING":
      case "PENDING":
        rpaStatusText.value = "⏳ 执行中，正在获取发票...";
        break;
    }
  } catch (err) {
    console.error("轮询异常", err);
  }
};

// 处理验证码显示逻辑（复用原有逻辑）
const handleCaptchaStatus = (captcha) => {
  if (!captcha) return;
  const { waiting, type, taskId, imageUrl } = captcha;

  if (waiting && type === 'CLICK_CAPTCHA') {
    captchaTaskId.value = taskId;
    // 假设后端返回的数据中有 tipImageUrl 和 bgImageUrl
    captchaTipImageUrl.value = captcha.tipImageUrl;
    captchaBgImageUrl.value = captcha.bgImageUrl;
    showCaptcha.value = true;
    showSmsCaptcha.value = false;
  }  else if (waiting && type === 'SMS') {
    smsTaskId.value = taskId;
    showSmsCaptcha.value = true;
    showCaptcha.value = false;
  } else {
    showCaptcha.value = false;
    showSmsCaptcha.value = false;
  }
}

// 打开取票弹窗
const getListOut = () => {
  rpaStatusText.value = "就绪，请点击【启动取票】开始";
  showRpaProgress.value = true;
};

// 真正启动任务
const startGetInvoiceList = async () => {
  // 1. 判空校验
  if (!params.start || !params.end) {
    message.warn("请选择取票日期");
    return;
  }

  // 2. 用原生 JS 转日期（兼容所有环境）
  const start = new Date(params.start);
  const end = new Date(params.end);

  // 3. 计算时间差（毫秒）
  const timeDiff = end.getTime() - start.getTime();
  const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

  // 4. 超过 92 天一律拦截（覆盖3个月最大天数）
  if (dayDiff > 92) {
    message.error("取票时间不能超过 3 个月，请重新选择！");
    return;
  }
  canCloseDialog.value = false;  // 👈 加这行
  rpaStatusText.value = "正在启动取票任务...";
  await doRealGetListOut();
};
const doRealGetListOut = async () => {
  // 防止重复点击，双重校验
  if (isRpaRunning.value || rpaPollingTimer) {
    message.warn("正在获取发票中，请勿重复操作");
    return;
  }

  try {
    loading.value = true;
    isRpaRunning.value = true;
    // 1. 调用接口启动 RPA 任务
    await Invoice.getTaxRpa("IN",params);
    message.success("已开始获取发票，请稍候...");
    rpaStatusText.value = "⏳ 已启动，正在连接税务局...";

    // 2. 启动轮询（1秒一次，实时性拉满）
    startRpaPolling();
  } catch (err) {
    loading.value = false;
    message.error("启动任务失败：" + (err?.msg || '未知错误'));
    isRpaRunning.value = false;
    stopRpaPolling();
  }
}

// 启动轮询
const startRpaPolling = () => {
  // 【关键】先强制清空所有旧定时器，绝对避免多个定时器同时运行
  stopRpaPolling();
  // 每1秒查询一次状态
  rpaPollingTimer = setInterval(checkRpaTaskStatus, 5000);
}

// 停止轮询（任务结束/页面销毁时必须调用）
const stopRpaPolling = () => {
  if (rpaPollingTimer) {
    clearInterval(rpaPollingTimer);
    rpaPollingTimer = null;
    loading.value = false;
  }
}

onUnmounted(() => {
  stopRpaPolling();
  if (rpaCooldownTimer.value) clearInterval(rpaCooldownTimer.value);
});

const params = reactive({
  start: startDate.value,
  end: endDate.value,
  voucherId: null,
  customerName: null,
  invoiceNumber: null,
  state: null,
  category: null,
});

const importInNum=() =>{
	let layerId = layer.open({
	title: "进项发票导入",
	shadeClose: false,
	closeBtn: false,
	zIndex: 1000,
	area: ['500px', 'auto'],
	content: h(InvoiceNumImport, {
		type:"IN",
		onClose: () => {
			loadList();
			layer.close(layerId);
		},
		onSuccess: () => {
			loadList();
			layer.close(layerId);
		}
	})
	});
}

const formatInvoiceCategory = ({cellValue}) => {
  let cate = categoryList.value.find(item=>item.key===cellValue);
  if (cate) return cate.title;
  return ""
};

const importIn=() =>{
	let layerId = layer.open({
	title: "进项发票导入",
	shadeClose: false,
	closeBtn: false,
	zIndex: 1000,
	area: ['500px', 'auto'],
	content: h(InvoiceImport, {
		type:"IN",
		onClose: () => {
			loadList();
			layer.close(layerId);
		},
		onSuccess: () => {
			loadList();
			layer.close(layerId);
		}
	})
	});
}

const resetForm = () => {
  Object.assign(params, {
    start: startDate.value,
    end: endDate.value,
    voucherId: null,
    customerName: null,
    invoiceNumber: null,
    state: null,
    category: null,
  })
  loadList();
  paramsDropdown.value.hide();
}
const props = defineProps(['categoryList'])
const {categoryList} = toRefs(props)
const pageList = ref({
  results: [],
  total: 0,
});
const xTable = ref(null);
const paramsDropdown = ref(null);
const loading = ref(false);
const total = ref(0);
const page = reactive({
  page: 1,
  pageSize: 20
});

const showNewForm = (key, entity,readonly) => {
  let cate = categoryList.value.find(item=>item.key===key);
  let layerId = layer.drawer({
    title: cate.title,
    shadeClose: false,
    closeBtn: false,
    zIndex: 1000,
    area: ['1200px', '100vh'],
    content: h(InvoiceForm, {
      entity,
      category: key,
      type: "IN",
      readonly:readonly,
      onClose: () => {
        layer.close(layerId);
      },
      onSuccess: () => {
        layer.close(layerId);
        loadList();
      }
    })
  });
}

const loadList = () => {
  loading.value = true;
  Invoice.list("IN", page, params).then(({data}) => {
    pageList.value = data;
    startDate.value = params.start;
    endDate.value = params.end;
    paramsDropdown.value.hide();
  }).finally(() => loading.value = false)
}
loadList();

const onPageChange = ({currentPage, pageSize}) => {
  page.page = currentPage;
  page.pageSize = pageSize;
  loadList();
}

const remove = (rows) => {
  confirm({
    content: "确认删除?",
    async: true,
    onConfirm(resolve) {
      let canDel = []
      rows.forEach(val => {
        if(!val.voucherId){
          canDel.push(val)
        }
      })
      if(canDel.length != rows.length){message(`本次提交处理【${rows.length}】条，成功处理【${canDel.length}】条~,已生成凭证的，请先删除凭证后再删除！`)}      
      Invoice.remove(canDel.map(val => val.id)).then(() => {
        resolve(true);
        loadList();
      }).catch(() => resolve(false))
    }
  })
}


const doAction = (action) => {
  const records = xTable.value.getCheckboxRecords();
  if (!records || !records.length || records.length<=0) {
    message.error('已至少选择一条记录进行操作')
    return;
  }
  switch (action) {
    case "批量删除":
      remove(records);
      break;
    case "批量反认证":
      confirm({
        content: `确认批量反认证这些记录吗?`,
        onConfirm: () => {
          Invoice.batchRevokeCheck(records.map(val => val.id)).then(({data}) => {
            message(`本次提交处理【${records.length}】条，成功处理【${data}】条~`)
            loadList();
          })
        }
      })
      break;
    case "指定业务类型":
    case "批量认证":
      let layerId = layer.open({
        title: action,
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['400px', 'auto'],
        content: h(action === '指定业务类型' ? InvoiceChangeBusinessType : InvoiceCheck, {
          rows: records,
          type: "IN",
          action: action,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            loadList();
          }
        })
      });
      break;
  }

}

const generateVoucher = () => {
  const records = xTable.value.getCheckboxRecords();
  if (records.length && records.every(val => !val.voucher)) {
    let layerId = layer.drawer({
      title: "生成凭证预览",
      shadeClose: false,
      zIndex: 999,
      area: ['1200px', '100vh'],
      content: h(InvoiceGenerateVoucher, {
        records,
        type: "IN",
        dateModel:paramDateValue.value,
        onClose: () => {
          layer.close(layerId);
          loadList();
        },
        onSuccess: () => {
          layer.close(layerId);
          loadList();
        }
      }),
      end: ()=>{
        // console.log(545)
        loadList();
      }
    });
  } else {
    message.warn("没有选择需要生成凭证的记录~");
  }
}

const checkMethod = ({row}) => {
  return !row.voucherId;
}
</script>
